var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('viewable-list-item',[_c('player-item-content',{attrs:{"player":_vm.player}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }